<template>
  <div :class="classes" @click.prevent="handleClick">
    <div class="image-navigator-image__check" v-if="!hideMoveMulti">
      <v-checkbox
        v-model="multiSelected"
        hide-details
        @click.stop="onMultiSelect"
      ></v-checkbox>
    </div>
    <div class="image-navigator-image__image">
      <v-lazy-image :src="imageURL" src-placeholder="/img/placeholder.png" />
    </div>
    <div
      v-if="!hideEditInPlace"
      class="image-navigator-image__description"
      @click.stop="activeEditMode"
    >
      <span
        class="image-navigator-image__description__value"
        v-if="!editMode"
        >{{ model.description || "Sem descrição" }}</span
      >
      <v-text-field
        ref="descriptionInput"
        v-if="editMode"
        v-model="model.description"
        @keyup.esc="onCancel"
        @keyup.enter="onEdit"
      ></v-text-field>
    </div>
    <div v-else class="image-navigator-image__description">
      <span
        class="
          image-navigator-image__description__value
          image-navigator-image__description__value--no-border
        "
        >{{ model.description || "Sem descrição" }}</span
      >
    </div>
    <div class="image-navigator-image__dimensions">
      {{ image.width }} x {{ image.height }}
    </div>
  </div>
</template>

<script>
import VLazyImage from "v-lazy-image/v2/v-lazy-image.es";
import ImageListItem from "../ImageListItem/ImageListItem.vue";
export default {
  components: {
    VLazyImage,
    "fluke-image-list-item": ImageListItem,
  },
  props: {
    image: Object,
    selected: Boolean,
    multiSelected: Boolean,
    hideEditInPlace: Boolean,
    hideMoveMulti: Boolean,
  },
  computed: {
    imageURL() {
      return `${this.$myServerAddresses.images}img/${this.image.name}`;
    },
    classes() {
      return {
        "image-navigator-image": true,
        "image-navigator-image--selected": this.selected,
        "image-navigator-image--multi-selected": this.multiSelected,
      };
    },
  },
  data() {
    return {
      model: {
        description: "",
      },
      editMode: false,
    };
  },
  created() {
    this.setModelData();
  },
  methods: {
    activeEditMode() {
      this.editMode = true;
      this.$nextTick(() => {
        this.$refs.descriptionInput.focus();
      });
    },
    disableEditMode() {
      this.editMode = false;
    },
    onEdit() {
      this.disableEditMode();
      this.$emit("update", {
        image: this.image,
        model: this.model,
      });
    },
    onCancel() {
      this.disableEditMode();
      this.model.description = this.image.description;
    },
    handleClick() {
      this.disableEditMode();
      this.$emit("click", this.image);
    },
    setModelData() {
      this.model.description = this.image.description;
    },
    onMultiSelect() {
      this.$emit("multi-select", this.image);
    },
  },
  watch: {
    "image.description": function () {
      this.$nextTick(() => {
        this.setModelData();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.image-navigator-image {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
  border-radius: 3px;
  position: relative;
  &:hover {
    background: #eee;
    .image-navigator-image__check {
      display: block;
    }
  }
  &--selected {
    background: #fec402;
    color: black;
    &:hover {
      background: #fec402;
      color: black;
    }
  }
  &--multi-selected {
    background: #ddd;
    .image-navigator-image__check {
      display: block;
    }
    &:hover {
      background: #ddd;
    }
  }
  &__check {
    position: absolute;
    top: 25px;
    left: 25px;
    display: none;
    padding: 3px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 3px;
    width: 30px;
    height: 30px;
    overflow: hidden;
  }
  &__image {
    display: flex;
    margin: 0 0 10px 0;
    img {
      width: 100%;
      height: 100px;
      object-fit: cover;
      display: block;
    }
  }
  &__description {
    margin: 0 0 3px 0;
    text-align: center;
    word-break: break-all;
    &__value {
      border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
      line-height: 1.5;
      &--no-border {
        border: 0;
      }
    }
  }
  &__dimensions {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
  }
}
</style>
